<template>
    <div class="registry-wrapper">
        <empty-table-message
            v-if="data.table && !data.table.length"
            msg="msg-empty-ven-cliente-mix"
        />
        <b-table v-else class="data-table" :data="data.table" @sort="loadSort" backend-sorting>
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :label="f.key != '' ? $t(f.key) : ''"
                :sortable="f.sortable"
                :width="f.width"
                v-slot="props"
            >
                <div v-if="f.key == 'valor'">
                    {{ formatValor(props.row[f.key]) }}
                </div>

                <div v-else-if="f.key == 'datahora'">
                    {{ props.row[f.key] | moment('L') }}
                </div>

                <div v-else-if="f.key == 'qtde'">
                    {{ formatQtde(props.row[f.key]) }}
                </div>

                <div v-else>{{ props.row[f.key] }}</div>
            </b-table-column>
        </b-table>
        <b-pagination
            order="is-centered"
            :total="data.total"
            :current.sync="data.page"
            :per-page="data.perPage"
            @change="loadPage"
        />
    </div>
</template>

<script>


export default {
    components: {

    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            msgs: [],
            fields: [
                { key: 'produto', sortable: true },
                { key: 'valor', sortable: true },
                { key: 'qtde', sortable: true },
                { key: 'datahora', sortable: true },
            ],
            column: '',
            order: '',
        };
    },
    methods: {
        showMessage(type, message) {
            let data = {
                type: type,
                message: message,
            };

            this.$emit('alert', data);
        },
        loadPage(pageNumber) {
            let query = {
                page: pageNumber,
                limit: this.data.perPage,
                column: this.column,
                order: this.order,
            };

            this.$emit('load-page', query);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;

            this.loadPage(this.data.page);
        },
        formatValor(valor) {
            if (this.data.cliente)
                return (
                    this.data.cliente.prefix + ' ' + Number(valor).toFixed(this.data.cliente.scale)
                );

            return (
                this.$store.state.empresas.data[0].simbolomonetario +
                Number(valor).toFixed(this.$store.state.empresas.data[0].valordecimalplaces)
            );
        },
        formatQtde(qtde) {
            if (this.data.cliente) return Number(qtde).toFixed(this.data.cliente.scaleqtd);

            return Number(qtde).toFixed(this.$store.state.empresas.data[0].valordecimalplaces);
        },
    },
};
</script>
